import jQuery from 'jquery';
import 'jquery-validate';
import { getCSRFToken } from '@shared/cookie';

export default {
  $form: jQuery('#forgot-password'),
  $fieldset: jQuery('#forgot-password').find('fieldset'),
  $controlGroup: jQuery('#forgot-password').find('.control-group'),
  $toggleBtn: jQuery('#forgot-password-toggle'),
  $submitBtn: jQuery('#forgot-password-submit'),
  $inputEmail: jQuery('#inputEmail'),
  $ajaxSpinner: jQuery('#ajax-spinner'),
  $error: jQuery('#forgot-password-error'),
  $serverError: jQuery('#forgot-password-server-error'),
  $pwdSent: jQuery('#pwd_sent'),
  init() {
    this.$form.hide();
    this.$toggleBtn.on('click', e => {
      e.preventDefault();
      this.$form.slideToggle(300, 'linear', function () {
        jQuery(this).css('overflow', '');
      });
    });

    this.validator = this.$form.validate({
      rules: {
        email: {
          required: true,
          email: true,
        },
      },
      highlight(element) {
        jQuery(element)
        .closest('.control-group')
        .removeClass('success is-valid')
        .addClass('error is-invalid');
      },
      unhighlight(element) {
        jQuery(element)
        .closest('.control-group')
        .removeClass('error is-invalid')
        .addClass('success is-valid');
      },
      errorPlacement(error, element) {
        element.parents('.control-group')
        .addClass('error is-invalid')
        .removeClass('success is-valid')
        .find('.help-inline')
        .append(error);
      },
    });
    this.$submitBtn.click(() => {
      this.retrieve();
    });
    this.$form.on('keypress', e => {
      if (e.which === 13) {
        this.retrieve();
        return false;
      }
      this.$serverError.hide();
    });
    this.$inputEmail.focusout(() => {
      this.validator.form();
    });
  },
  retrieve() {
    const self = this;

    if (this.validator.form()) {
      jQuery.ajax({
        type: 'POST',
        data: {
          email: this.$inputEmail.val(),
          csrf_token: getCSRFToken(),
        },
        url: '/users/ajaxonforgotpassword.php',
        jsonpCallback: 'jsonpCallback',
        dataType: 'jsonp',
        // Work around for handling JSONP errors.
        // If the request exceeds 10s, there should be something wrong.
        timeout: 10000,
        beforeSend() {
          jQuery('#inputEmail').attr('disabled', 'disabled');
          self.$serverError.hide();
          self.$submitBtn.hide();
          self.$ajaxSpinner.show();
        },
        success(response) {
          self.$ajaxSpinner.hide();
          if (response.status === 'success') {
            self.$pwdSent.show();
            setTimeout(() => {
              self.$pwdSent.fadeOut(1000, () => {
                self.$submitBtn.show();
                jQuery('#inputEmail').removeAttr('disabled');
              });
            }, 9999);
          } else {
            jQuery('#inputEmail').removeAttr('disabled');
            if (typeof response.msg !== 'undefined' &&
            response.msg.length > 0) {
              self.$controlGroup
              .removeClass('success is-valid')
              .addClass('error is-invalid');
              self.$error.html('');
              if (typeof response.msg === 'string') {
                self.$error.append(response.msg);
              } else if (typeof response.msg === 'object') {
                self.$error
                .append(response.msg.join('<br/>'));
              }
              self.$error.show();
              self.$submitBtn.show();
            }
          }
        },
        error() {
          jQuery('#inputEmail').removeAttr('disabled');
          self.$serverError.show();
          self.$submitBtn.show();
          self.$ajaxSpinner.hide();
        },
      });
    }
  },
};
